import React, { useState } from 'react';
import AwsChatbot from '../AwsChatbot';
import { useOktaAuth } from '@okta/okta-react';

const styles = {
  container: { padding: '2rem', fontFamily: 'sans-serif', textAlign: 'center' },
  header: { borderBottom: '2px solid #eee', paddingBottom: '1rem', marginBottom: '2rem' },
  blurredContent: {
    filter: 'blur(8px)',
    opacity: 0.6,
    pointerEvents: 'none',
    userSelect: 'none',
    border: '1px dashed #ccc',
    padding: '2rem',
    margin: '2rem 0'
  },
  premiumFeature: {
    marginTop: '2rem',
    padding: '1.5rem',
    border: '1px solid #007bff',
    borderRadius: '8px',
    backgroundColor: '#f0f8ff'
  },
  button: {
    padding: '0.8rem 1.5rem',
    fontSize: '1rem',
    cursor: 'pointer',
    backgroundColor: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    transition: 'background-color 0.2s',
  },
  buttonDisabled: {
    backgroundColor: '#6c757d',
    cursor: 'not-allowed',
  },
  accessDenied: {
    color: '#dc3545',
    fontWeight: 'bold',
    marginTop: '2rem',
    padding: '1rem',
    backgroundColor: '#f8d7da',
    borderRadius: '8px',
    border: '1px solid #f5c6cb',
  }
};

const DSVPage = () => {
  const { authState } = useOktaAuth();
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [refreshMessage, setRefreshMessage] = useState('');

  // Assumption: 'subscription' claim is in the ID token.
  const isPremiumUser = authState?.idToken?.claims?.subscription === 'Premium';

  const handleRefresh = async () => {
    setIsRefreshing(true);
    setRefreshMessage('Requesting data refresh...');
    try {
      // Mock API call. In a real app, you would make a POST request
      // to your backend with the user's access token.
      await new Promise(resolve => setTimeout(resolve, 1500));
      setRefreshMessage('Success! The health cards have been queued for a refresh.');
    } catch (error) {
      console.error('Failed to refresh DSV data:', error);
      setRefreshMessage('An error occurred. Please try again later.');
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div style={styles.container} className="ecosystem-page">
      <header style={styles.header}>
        <h1>Digital Specimen Viewer (DSV)</h1>
        <p>View and manage your digital health cards/records.</p>
      </header>

      <div style={styles.blurredContent}>
        <img src="https://via.placeholder.com/800x400.png?text=Blurred+Health+Card+Images" alt="Blurred content" />
      </div>

      {isPremiumUser ? (
        <div style={styles.premiumFeature}>
          <h3>Premium Feature: On-Demand Refresh</h3>
          <p>If your health cards appear stalled or incorrect, you can request an on-demand refresh.</p>
          <button onClick={handleRefresh} disabled={isRefreshing} style={{...styles.button, ...(isRefreshing && styles.buttonDisabled)}}>
            {isRefreshing ? 'Refreshing...' : 'Refresh Health Cards'}
          </button>
          {refreshMessage && <p style={{ marginTop: '1rem' }}>{refreshMessage}</p>}
        </div>
      ) : (
        <div style={styles.accessDenied}>
          The on-demand refresh feature is available exclusively for Premium users. Upgrade your plan to access this and other exclusive benefits.
        </div>
      )}
      <AwsChatbot />
    </div>
  );
};

export default DSVPage;